import React from 'react';

export default ({ color, width, height }) => (
  <svg version="1.1" id="Layer_1" width={width} height={height} viewBox="0 0 51 45">
    <g id="Page-1">
      <g id="Alexa">
        <path
          id="Shape"
          style={{ fill: color }}
          d="M50.8,14.8l0.1,0.2c0-0.2,0-0.4,0-0.6C50.9,14.6,50.9,14.7,50.8,14.8z M0,14.4c0,0.2,0,0.4,0,0.7
			l0.1-0.2C0,14.7,0,14.6,0,14.4z"
        />
        <path
          id="Shape_1_"
          style={{ fill: color }}
          d="M25.5,11.9c-3.4,0-6-1.5-6-3.4c0-1.9,2.6-3.4,6-3.4s6,1.5,6,3.4C31.4,10.4,28.9,11.9,25.5,11.9
			z M25.5,6.8c-2.6,0-4.3,1-4.3,1.7s1.7,1.7,4.3,1.7s4.2-1,4.2-1.7S28.1,6.8,25.5,6.8z"
        />
        <path
          id="Shape_2_"
          style={{ fill: color }}
          d="M11,17.8c-3.4,0-6-1.5-6-3.4S7.6,11,11,11c3.4,0,6,1.5,6,3.4S14.4,17.8,11,17.8z M11,12.7
			c-2.6,0-4.2,1-4.2,1.7c0,0.7,1.6,1.7,4.2,1.7s4.3-1,4.3-1.7C15.3,13.7,13.6,12.7,11,12.7z"
        />
        <path
          id="Shape_3_"
          style={{ fill: color }}
          d="M39.9,17.8c-3.4,0-6-1.5-6-3.4s2.6-3.4,6-3.4c3.4,0,6,1.5,6,3.4S43.3,17.8,39.9,17.8z
			 M39.9,12.7c-2.6,0-4.3,1-4.3,1.7c0,0.7,1.7,1.7,4.3,1.7c2.6,0,4.2-1,4.2-1.7C44.2,13.7,42.5,12.7,39.9,12.7z"
        />
        <path
          id="Shape_4_"
          style={{ fill: color }}
          d="M25.5,23.8c-3.4,0-6-1.5-6-3.4s2.6-3.4,6-3.4s6,1.5,6,3.4S28.9,23.8,25.5,23.8z M25.5,18.7
			c-2.6,0-4.3,1-4.3,1.7s1.7,1.7,4.3,1.7s4.2-1,4.2-1.7S28.1,18.7,25.5,18.7z"
        />
        <path
          id="Path"
          style={{ fill: color }}
          d="M25.5,15.3c-0.2,0-0.4-0.1-0.6-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3
			c0-0.2,0.1-0.4,0.3-0.5c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2c0.2,0.1,0.3,0.3,0.3,0.5c0,0.1,0,0.2-0.1,0.3
			c0,0.1-0.1,0.2-0.2,0.3C25.9,15.2,25.7,15.3,25.5,15.3z"
        />
        <path id="Path_1_" style={{ fill: color }} d="M2.1,8.7C2,8.8,1.9,8.9,1.8,9V9C1.9,8.9,2,8.8,2.1,8.7z" />
        <path
          id="Path_2_"
          style={{ fill: color }}
          d="M49.1,9.1C49,8.9,49,8.8,48.9,8.7C49,8.8,49,8.9,49.1,9.1L49.1,9.1z"
        />
        <path
          id="Path_3_"
          style={{ fill: color }}
          d="M25.5,15.3c-0.2,0-0.4-0.1-0.6-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3
			c0-0.2,0.1-0.4,0.3-0.5c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2c0.2,0.1,0.3,0.3,0.3,0.5c0,0.1,0,0.2-0.1,0.3
			c0,0.1-0.1,0.2-0.2,0.3C25.9,15.2,25.7,15.3,25.5,15.3z"
        />
        <path
          id="Shape_5_"
          style={{ fill: color }}
          d="M51,15.1l-0.1-0.2c0.1-0.1,0.1-0.3,0.1-0.4c0-1.9-0.7-3.8-1.8-5.3C49.1,9,49,8.8,48.9,8.7
			C45,3.6,36,0,25.5,0S6,3.6,2.1,8.7C2,8.8,2,8.9,1.9,9.1c-1.2,1.6-1.8,3.4-1.8,5.4c0,0.2,0,0.3,0.1,0.4l-0.1,0.2v0.2v15.3
			C0.1,38.5,11.5,45,25.6,45c14,0,25.4-6.5,25.4-14.4V15.3V15.1L51,15.1z M2.6,13.6H1.8c0.1-1.1,0.5-2.2,1.1-3.1l1,0.5
			C4,11,4.1,11,4.3,11c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.3-0.3,0.3-0.5c0-0.2,0-0.4-0.1-0.6S4.8,9.5,4.6,9.4L3.9,9
			c0.8-0.9,1.6-1.6,2.5-2.3L7,7.4c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.5-0.2S8.4,7,8.4,6.8s0-0.4-0.2-0.6L7.9,5.9
			c1.3-0.8,2.7-1.5,4.2-2l0.1,0.1L13,4.8C13.1,4.9,13.4,5,13.6,5c0.2,0,0.3-0.1,0.5-0.1c0.1-0.1,0.2-0.2,0.3-0.4
			c0.1-0.2,0.1-0.3,0-0.5c0-0.2-0.1-0.3-0.2-0.4l-0.3-0.3c1.4-0.4,2.8-0.7,4.2-1l0.8,0.8c0.2,0.1,0.3,0.2,0.5,0.2
			c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.3-0.5c0-0.2,0-0.4-0.1-0.6c1.5-0.2,2.9-0.3,4.4-0.3v0.8c0,0.1,0,0.2,0,0.4
			c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.3-0.2
			c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0-0.2,0-0.4V1.7c1.5,0,3,0.1,4.4,0.3c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.3,0.1,0.5
			c0.1,0.1,0.2,0.2,0.4,0.3c0.2,0.1,0.3,0.1,0.5,0.1c0.2,0,0.3-0.1,0.4-0.2l0.8-0.8c1.4,0.2,2.8,0.6,4.2,1l-0.3,0.3
			c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.1-0.1,0.2-0.1,0.3c0,0.2,0.1,0.3,0.1,0.5C36.7,4.8,36.9,4.9,37,5c0.2,0.1,0.3,0.1,0.5,0.1
			c0.2,0,0.3-0.1,0.4-0.2L38.8,4l0.1-0.1c1.4,0.5,2.8,1.2,4.2,2l-0.3,0.3c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.1-0.1,0.2-0.1,0.3
			c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1
			c0.1,0,0.2-0.1,0.3-0.2l0.6-0.6c0.9,0.7,1.8,1.4,2.5,2.3l-0.7,0.4c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.4-0.1,0.6
			s0.2,0.4,0.3,0.5c0.2,0.1,0.3,0.2,0.5,0.2c0.1,0,0.3,0,0.4-0.1l1-0.5c0.6,0.9,1,2,1.1,3.1h-0.8c-0.2,0-0.4,0.1-0.6,0.2
			c-0.2,0.2-0.2,0.4-0.2,0.6c0,0.2,0.1,0.4,0.2,0.6c0.2,0.2,0.4,0.2,0.6,0.2h0.8c-0.1,1.1-0.5,2.2-1.1,3.1l-1-0.5
			c-0.2-0.1-0.4-0.1-0.6,0c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.1,0.4,0,0.6c0.1,0.2,0.2,0.4,0.4,0.5l0.7,0.4
			c-0.8,0.9-1.6,1.6-2.5,2.3l-0.6-0.6c-0.2-0.2-0.4-0.2-0.6-0.2c-0.2,0-0.4,0.1-0.6,0.3c-0.2,0.2-0.2,0.4-0.2,0.6
			c0,0.2,0.1,0.4,0.3,0.6L43,23c-1.3,0.8-2.7,1.5-4.2,2l-0.1-0.1l-0.9-0.9c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.4,0.1-0.6,0.2
			c-0.1,0.1-0.2,0.3-0.2,0.6c0,0.2,0.1,0.4,0.2,0.6l0.3,0.3c-1.4,0.4-2.8,0.7-4.2,1L32,25.8c-0.2-0.2-0.4-0.2-0.6-0.2
			c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.2,0.3-0.3,0.6c0,0.2,0.1,0.4,0.2,0.6c-1.5,0.2-3,0.3-4.4,0.3v-0.9c0-0.1,0-0.2,0-0.4
			c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.3,0.2
			c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.2,0,0.4v0.8c-1.5,0-3-0.1-4.4-0.3c0.1-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.3-0.6
			c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.4,0.1-0.6,0.3l-0.8,0.8c-1.4-0.2-2.8-0.6-4.2-1l0.3-0.3c0.2-0.2,0.2-0.4,0.2-0.6
			c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.2-0.4-0.2-0.6-0.2c-0.2,0-0.4,0.1-0.6,0.2l-0.8,0.9L12.1,25c-1.4-0.5-2.8-1.2-4.2-2l0.3-0.3
			c0.1-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.1-0.3-0.2-0.6-0.2c-0.2,0-0.4,0.1-0.6,0.2L6.4,22
			c-0.9-0.7-1.8-1.4-2.5-2.3l0.7-0.4c0.1,0,0.2-0.1,0.3-0.2C5,19.1,5.1,19,5.1,18.9c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3
			C5,18.1,4.9,18,4.8,17.9c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2,0-0.4,0s-0.2,0.1-0.3,0.1l-1,0.5c-0.6-0.9-1-2-1.1-3.1h0.8
			c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6C3,13.6,2.7,13.5,2.6,13.6L2.6,13.6z M49.2,30.6
			c0,7-10.7,12.7-23.8,12.7c-13.1,0-23.8-5.7-23.8-12.7V19.6l0.1,0.2l0.2,0.3C6,25.3,15,28.9,25.5,28.9c10.5,0,19.5-3.6,23.4-8.7
			c0.1-0.1,0.2-0.2,0.3-0.4l0.1-0.2V30.6z"
        />
        <path id="Path_4_" d="M49.1,19.8L49.1,19.8c-0.1,0.2-0.1,0.3-0.2,0.4C49,20,49.1,19.9,49.1,19.8z" />
        <path
          id="Path_5_"
          style={{ fill: color }}
          d="M29.7,34.8h-8.5c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.2,0.1-0.4,0.2-0.6
			c0.1-0.2,0.3-0.3,0.5-0.3h8.5c0.2,0,0.4,0.1,0.5,0.3c0.1,0.2,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.2,0.6
			C30.1,34.7,29.9,34.8,29.7,34.8z"
        />
        <path
          id="Path_6_"
          style={{ fill: color }}
          d="M29.7,38.2h-8.5c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.2,0.1-0.4,0.2-0.6
			c0.1-0.2,0.3-0.3,0.5-0.3h8.5c0.2,0,0.4,0.1,0.5,0.3c0.1,0.2,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.2,0.6
			C30.1,38.1,29.9,38.2,29.7,38.2z"
        />
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/resources/react-svg/Alexa.js